import React, { Component } from "react";
import _ from "lodash";

import Close from "@safecv/assets/Images/cancel.png";

class PageView extends Component {
  close = (id) => {
    document.getElementById("symbol-property-" + id).style.display = "none";
  };

  render() {
    let props = this.props;
    let annotation = props.annotation;
    let message = annotation.annotationSpecificMessage;
    let symbolProperty = {};

    if (
      annotation.displayPropertyJson != undefined &&
      annotation.displayPropertyJson !== "{}"
    ) {
      symbolProperty = JSON.parse(annotation.displayPropertyJson);
    } else if (annotation.propertyFlag) {
      symbolProperty = JSON.parse(annotation.propertyJson);
    }

    var displayProperty =
      symbolProperty &&
      Object.keys(symbolProperty).map(function (key) {
        if (
          //This condition can be removed after WIN_NOTE detection issue is resolved.
          (key === "Ventilation" || key === "Illumination") &&
          (symbolProperty[key] === "NA" ||
            symbolProperty[key] === "0.0 sq ft" ||
            symbolProperty[key] === 0)
        ) {
          return (
            <div className="flex-box symbol-property">
              <div
                title={key}
                className="flex-bipartite symbol-property-value wrap-overflow-text"
              >
                {key}
              </div>
              <div
                className="flex-bipartite symbol-property-value symbol-property-failure wrap-overflow-text"
                title="Window dimension detection failed"
              >
                NA
              </div>
            </div>
          );
        } else
          return (
            <div className="flex-box symbol-property">
              <div
                title={key}
                className="flex-bipartite symbol-property-value wrap-overflow-text"
              >
                {key}
              </div>
              <div
                title={`${symbolProperty[key]}`}
                className="flex-bipartite symbol-property-value wrap-overflow-text"
              >
                {`${symbolProperty[key]}`}
              </div>
            </div>
          );
      });
    return (
      <div
        className="annotation-wrapper"
        ref={props.annotationRefs[annotation.annotationName]}
      >
        <div
          className={
            annotation.annotationName === props.selectedAnnotation
              ? "showbox showbox-active"
              : "showbox"
          }
          key={annotation.id}
          id={annotation.id}
          onClick={() => {
            props.setSelectedAnnotation(annotation.annotationName);
            if (!_.isEmpty(displayProperty))
              document.getElementById(
                "symbol-property-" + annotation.id
              ).style.display = "block";
          }}
        >
          {message}
        </div>
        {!_.isEmpty(displayProperty) ? (
          <div
            className="annotation-display-properties"
            id={"symbol-property-" + annotation.id}
          >
            <div className="flex-box">
              <div className="card-details">{displayProperty}</div>
              <div>
                <img
                  className="close-button"
                  src={Close}
                  alt="close"
                  onClick={() => this.close(annotation.id)}
                ></img>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default PageView;
